export const SELECTED_ACCOUNTS_SESSION_KEY = 'shipments_selected_accounts';